import tw from "twin.macro";

export const CategoriesGridSection = tw.section`w-full p-[2.75rem] grid grid-cols-4 gap-12`